import ConnectSection from "@app/components/connect-section";
import ExpectationsSection from "@app/components/partners-sections/expectations-section";
import LookingForSection from "@app/components/partners-sections/looking-for-section";
import PointOfViewSection from "@app/components/partners-sections/point-of-view-section";

const PartnersPage = () => (
  <div>
    <LookingForSection />
    <ExpectationsSection />
    <PointOfViewSection />
    <ConnectSection variant="light" />
  </div>
);

export default PartnersPage;
